<div class="page">
  <app-page-header 
    itemName="" 
    page-title="{{ property.get('name') }}"
    isPropertyHome = "true"
    hideList = "{{ loggedUserShared }}"
  >
  </app-page-header>
  <div class="page-content">
    <div class="alert alert-danger text-center my-4" *ngIf="propertyData && !propertyData.active">
      {{ 'properties.detail.suspended_property_alert' | translate }}
    </div>
    <mat-card class="custom-card mt-4">
      <div class="row">
        <div class="col-6">
          <mat-card-title>{{ 'properties.caretakersPage.documentsTab.title' | translate }}
          </mat-card-title>
          <mat-card-subtitle>{{ property.get('name') }}</mat-card-subtitle>
        </div>
        <div class="col-6">

        </div>
      </div>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-12">
              <app-card-spinner [visible]="documentArchiveIsLoading" type="zero"></app-card-spinner>
              <div class="row">
                <div class="col-6">
                  <mat-form-field>
                    <mat-label>{{ 'common.filter' | translate }}</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="">
                  </mat-form-field>
                </div>
                <div class="col-6 text-right">
                  <button class="navigation-button" mat-flat-button (click)="onExportToExcel()" color="primary">
                    <mat-icon fontSet="fal" fontIcon="fa-file-export"></mat-icon>
                    {{ 'common.export' | translate }}
                  </button>
                </div>
              </div>

              <ng-container>
                <table class="table table-borderless table-striped" matSort (matSortChange)="sortData($event)" matSortDisableClear id="excel-table">
                  <thead>
                    <th>#</th>
                    <th class="clickable" mat-sort-header="tipologia">
                      {{ 'properties.structures.fields.dipendenti.tipologia' | translate }}</th>
                    <th class="clickable" mat-sort-header="nomeFornitore">
                      {{ 'properties.structures.fields.dipendenti.nomeFornitore' | translate }}</th>
                    <th class="clickable" mat-sort-header="cognomeNome">
                      {{ 'properties.structures.fields.dipendenti.cognomeNome' | translate }}</th>
                    <th class="clickable" mat-sort-header="telefonoFisso">
                      {{ 'properties.structures.fields.dipendenti.telefonoFisso' | translate }}</th>
                    <th class="clickable" mat-sort-header="telefonoMobile">
                      {{ 'properties.structures.fields.dipendenti.telefonoMobile' | translate }}</th>
                    <th class="clickable" mat-sort-header="orari">
                      {{ 'properties.structures.fields.dipendenti.orari' | translate }}</th>
                    <th class="clickable" mat-sort-header="email">
                      {{ 'properties.structures.fields.dipendenti.email' | translate }}</th>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of sortedData; let i = index">
                      <th style="width: 3%">{{ i + 1 }}</th>
                      <td style="width: 11%">{{ item.tipologia }}</td>
                      <td style="width: 13%">{{ item.nomeFornitore }}</td>
                      <td style="width: 13%">{{ item.cognomeNome }}</td>
                      <td style="width: 10%">{{ item.telefonoFisso }}</td>
                      <td style="width: 10%">{{ item.telefonoMobile }}</td>
                      <td style="width: 20%">{{ item.orari }}</td>
                      <td style="width: 20%">{{ item.email }}</td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>
            </div> <!-- /.col -->
          </div> <!-- /.row -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->